export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11679.3328c59e.jpg";